import React, { useState } from "react";
import { Popover, Box, TextField, Button, Typography } from "@mui/material";
import { addPostLink } from "../live-campaign-repository";
import { LoadingButton } from '@mui/lab';

const AddPostLinkPopover = ({ anchorEl, handleClose, campaignId, creatorId, postLink, setPostLink, setRateAdded, error, setError }) => {
  const open = Boolean(anchorEl);
  const [loading, setLoading] = useState(false);

  const isValidUrl = (url) => {
    try {
      const parsed = new URL(url);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch (_) {
      return false;
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    addPostLink(campaignId, postLink, creatorId, setRateAdded, handleClose, setError, setLoading);
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Box
        sx={{
          width: 400,
          p: 3,
          bgcolor: "background.paper",
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            mb: 1,
            color: "#464646",
            fontWeight: 600,
            fontSize: "20px",
            fontFamily: "sans-serif",
          }}
        >
          Add Post Link
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mb: 2,
            color: "#8A8989",
            fontWeight: 400,
            fontSize: "14px",
            fontFamily: "sans-serif",
          }}
        >
          Enter post Link (e.g., https://example.com/post)
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <TextField
            fullWidth
            type="text"
            value={postLink}
            name="postLink"
            onChange={(e) => { setPostLink(e.target.value); setError("") }}
            placeholder="Enter Link"
            error={
              !!postLink && (!isValidUrl(postLink) || !!error)
            }
            helperText={
              !!postLink && !isValidUrl(postLink)
                ? "Please enter a valid URL starting with http:// or https://"
                : error || ""
            }
            sx={{
              "& .MuiOutlinedInput-root": {
                borderColor: "#464646",
                borderWidth: "2px",
                "&:hover fieldset": { borderColor: "#464646" },
                "&.Mui-focused fieldset": { borderColor: "#464646" },
              },
            }}
          />
        </Box>

        <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button
            variant="outlined"
            sx={{
              color: "#464646",
              borderColor: "#CECECE",
              "&:hover": { borderColor: "#8A8989", backgroundColor: "#F2F2F2" },
            }}
            onClick={handleClose}
          >
            Cancel
          </Button>

          <LoadingButton
            loading={loading}
            loadingPosition="center"
            variant="contained"
            disabled={!isValidUrl(postLink)}
            sx={{
              backgroundColor: "#65308F",
              color: "#fff",
              "&:hover": { backgroundColor: "#4A1A6D" },
            }}
            onClick={handleSubmit}
          >
            {!loading && "Add"}
          </LoadingButton>
        </Box>
      </Box>
    </Popover>
  );
};

export default AddPostLinkPopover;
